import {
  ArtistType,
  OrganizationUnitType,
  PermissionNameUnionType,
} from '@api';
import {
  TouringCardTable,
  TouringCardTableBody,
  useFilterPermittedItems,
} from '@common';
import { GeneralInformationTableRow } from './components';
import { generalInformationRows } from './data';

type GeneralInformationTablePropsType = {
  artist: ArtistType;
  organizationUnits: OrganizationUnitType[];
};

export const GeneralInformationTable: React.FC<
  GeneralInformationTablePropsType
> = ({ artist, organizationUnits }) => {
  const { filterPermittedItems } =
    useFilterPermittedItems<PermissionNameUnionType>();

  const filteredGeneralInformationRows = filterPermittedItems(
    generalInformationRows
  );

  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {filteredGeneralInformationRows.map((row) => (
          <GeneralInformationTableRow
            key={row.label}
            artist={artist}
            row={row}
            organizationUnits={organizationUnits}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
